const Dashboard = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Data Sources</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* <DataSourceList sources={dataSources} /> */}
        <div>
          {/* <FileUpload /> */}
          <div className="mt-4">
            <p className="text-sm">
              Total detected characters: 0 / 11,000,000 limit
            </p>
            {/* <Button>Create Chatbot</Button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
